import { createSelector } from '@ngrx/store';

import { AppStates } from '../state/app.state';
import { LayoutState } from '../state/layout.state';

const selectLayout = (state: AppStates) => state.layout;

export const selectLayoutError = createSelector(selectLayout, (state: LayoutState) => {
  return state.isApiError;
});

export const selectLayoutState = createSelector(selectLayout, (state: LayoutState) => {
  return state;
});

export const selectVersionError = createSelector(selectLayout, (state: LayoutState) => {
  return state.isVersionError;
});

export const selectSaveSuccess = createSelector(selectLayout, (state: LayoutState) => {
  return state.saveSuccess;
});

export const selectForceCloseCurrentModal = createSelector(selectLayout, (state: LayoutState) => {
  return state.forceCloseCurrentModal;
});
